export default "__VITE_ASSET__DjYoL1sJ__"